// The app's first clipboard write, so it carries the insecure-context fallback
// rather than assuming `navigator.clipboard`: that API is undefined outside a
// secure context, and this project's dev server is routinely reached over a LAN
// IP (http://192.168.x.x), where the modern path would throw and a Copy button
// would look broken for no visible reason.
//
// The fallback is `document.execCommand('copy')` — deprecated, but it is the
// only thing that works there and no current browser has dropped it.

/** Copy `text` to the clipboard. Throws if neither path succeeds. */
export const copyText = async (text: string): Promise<void> => {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }

  const field = document.createElement('textarea');
  field.value = text;
  // Off-screen but still selectable; readOnly keeps a mobile keyboard closed.
  field.setAttribute('readonly', '');
  field.style.position = 'fixed';
  field.style.insetInlineStart = '-9999px';
  document.body.appendChild(field);
  field.select();
  const copied = document.execCommand('copy');
  field.remove();
  if (!copied) throw new Error('Copy failed');
};
